import React from 'react'
import { Button, Layout, Result } from 'antd'
import { $, key } from '../localization/localization'

class NoMatch extends React.Component {

  render () {
    return (
      <Layout className='home-body-layout'>
        <Layout.Content className='home-body-content'>
          <div className='no-match'>
            <Result status="404"
                    title="404"
                    subTitle={$(key.noMatchTitle)}
                    extra={<Button type="primary"
                                   href='/'>{$(key.backToDashboard)}</Button>} />
          </div>
        </Layout.Content>
      </Layout>
    )
  }
}

export default NoMatch